import React from 'react';
import ResponsiveDialogManager from '../../components/dialog/ResponsiveDialogManager';
import ChangePasswordForm from '../../components/forms/ChangePasswordForm';
import {useTranslation} from "react-i18next";

export default function ChangePassword() {
  const {t} = useTranslation();
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{
      backgroundColor: '#303030',
      width: 'auto',
      height: '100vh',
    }}>
      <ResponsiveDialogManager
        open={open}
        renderer={<ChangePasswordForm/>}
        title={t('account.updatePasswordForm.newPassword')}
        onClose={handleClose}
        noClose
      />
    </div>
  )
}
